import React from "react";
import { Button } from "@exiftrator/shared/components/ui";
import {
  MOBILE_WORKSPACE_ORDER,
  WORKSPACE_VIEW_META,
} from "./Workspace/workspaceViewMeta";

const NAV_ITEMS = MOBILE_WORKSPACE_ORDER.map((workspaceId) =>
  WORKSPACE_VIEW_META[workspaceId],
);

function MobileWorkspaceSwitcher({ activeView, onViewChange }) {
  return (
    <nav className="fixed inset-x-0 bottom-[env(safe-area-inset-bottom)] z-50 border-t border-border-default bg-bg-secondary/95 px-3 py-2 backdrop-blur-sm">
      <div className="mx-auto flex w-full max-w-md items-center gap-2">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = activeView === item.id;

          return (
            <Button
              key={item.id}
              variant={isActive ? "secondary" : "ghost"}
              className="h-11 flex-1 justify-center gap-2"
              aria-current={isActive ? "page" : undefined}
              aria-label={item.label}
              onClick={() => onViewChange(item.id)}
            >
              <Icon className="size-4" />
              <span className="text-xs font-semibold tracking-wide">
                {item.label}
              </span>
            </Button>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileWorkspaceSwitcher;
